//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

/**
     * EVENTS :
     * startCollapse => emit event when transition collapse sidebar starts
     * startExpand => emit event when transition expand sidebar starts
     * endCollapse => emit event when transition collapse sidebar ends
     * endExpand => emit event when transition expand sidebar ends
     */

export default {
    name: "AQLeftSideBar",
    components: {
        AQTooltip
    },
    props: {
        atId: { type: String, default: "left-sidebar" },
        dynamicSidebar: { type: Boolean, default: false } // set dynamic sidebar (expand / collapse) or static sidebar
    },
    data() {
        return {
            closeSideBar: false,
            showContent: true
        };
    },
    computed: {
        getTooltipContent() {
            return this.$t(`generic.${this.closeSideBar ? "expand" : "collapse"}`);
        }
    },
    mounted() {
        const element = this.$refs.leftSideBarId;
        element.addEventListener("transitionend", this.transitionendTriggered);
        element.addEventListener("transitionstart", this.transitionstartTriggered);
    },
    methods: {
        actionExpandCollapse() {
            this.closeSideBar = !this.closeSideBar;
            this.$emit("triggerExpandCollapse", this.closeSideBar);
        },
        transitionstartTriggered(event) {
            if (event && event.propertyName === "width") {
                if (this.closeSideBar) {
                    this.showContent = false;
                    this.$emit("startCollapse");
                } else {
                    this.$emit("startExpand");
                }
            }
        },
        transitionendTriggered(event) {
            if (event && event.propertyName === "width") {
                if (this.closeSideBar) {
                    this.$emit("endCollapse");
                } else {
                    this.showContent = true;
                    this.$emit("endExpand");
                }
                if (!this.closeSideBar) {
                    this.showContent = true;
                }
            }
        }
    }
};
